module.exports = __webpack_public_path__ + "img/medal_light.c6154a27.svg";